import { QueryClient } from '@tanstack/react-query';

/**
 * Shared TanStack Query client. Defaults picked for an authenticated
 * dashboard workload: short-ish stale, no focus-refetch spam, one retry.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        retry: 1,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: 0,
      },
    },
  });
}
